import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import InfoIcon from "@material-ui/icons/Info";
import { TimePicker } from "@material-ui/pickers";
import moment from "moment-timezone";
import React from "react";
import { languages } from "../../constants/languages";
import EditSponsorElement from "../EditSponsorElement";

export default class EditFieldDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {this.props.field
            ? languages.schedule.editField
            : languages.schedule.addField}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            <TextField
              autoFocus
              margin="dense"
              label={languages.general.name}
              value={this.props.name}
              name="name"
              onChange={this.props.handleChange}
              type="text"
              fullWidth
            />
            <br />
            <br />

            <TimePicker
              name="startTime"
              ampm={false}
              label={languages.schedule.startTime}
              value={
                this.props.startTime
                  ? moment(this.props.startTime, "HH:mm")
                  : null
              }
              onChange={this.props.handleStartTimeChange}
              fullWidth
              cancelLabel={languages.general.cancel}
            />

            <br />
            <br />
            {(this.props.tournament[".key"] === "mHZrY1VskDo2Scfnnn6j" ||
              this.props.tournament[".key"] === "C6KUKTMksMzAuN3h21Er" ||
              this.props.tournament[".key"] === "PQruJgfJL1KbH5nlJb8x" ||
              this.props.tournament[".key"] === "ePAgSKQsqpVI2CQd1Ijq" ||
              this.props.tournament[".key"] === "aVP77PkczLUJdBjCIF4i" ||
              this.props.tournament[".key"] === "45NTFrpDU0hCnZcaQ1AF" ||
              this.props.tournament[".key"] === "Ob9tQGgviuwdch6opPd7" ||
              this.props.tournament[".key"] === "NdXzABVuQWZc4Q3GiTHz" ||
              this.props.tournament[".key"] === "fcqagH5pFsHyEOg9BwQE") && (
              <div style={{ marginBottom: 15 }}>
                <TimePicker
                  clearable
                  name="endTime"
                  ampm={false}
                  label={languages.schedule.endTime}
                  value={
                    this.props.endTime
                      ? moment(this.props.endTime, "HH:mm")
                      : null
                  }
                  onChange={this.props.handleEndTimeChange}
                  fullWidth
                  clearLabel={languages.schedule.clear}
                  cancelLabel={languages.general.cancel}
                />
              </div>
            )}
            <div>
              <FormGroup style={{ marginTop: 5 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.props.showSponsor}
                      onChange={this.props.handleShowSponsorChange}
                      color="primary"
                      name="showSponsor"
                    />
                  }
                  label={languages.schedule.fieldLogo}
                />
                {this.props.showSponsor && (
                  <div>
                    {this.props.allowedToUpload ? (
                      <EditSponsorElement
                        tournament={this.props.tournament}
                        sponsorName={this.props.sponsorName}
                        sponsorLogoURL={this.props.sponsorLogoURL}
                        sponsorStorageRef={this.props.sponsorStorageRef}
                        handleDeleteSponsor={this.props.handleDeleteSponsor}
                        handleUploadStart={this.props.handleUploadStart}
                        handleProgress={this.props.handleProgress}
                        handleUploadError={this.props.handleUploadError}
                        handleUploadSuccess={this.props.handleUploadSuccess}
                        allowedToUpload={this.props.allowedToUpload}
                        handleSponsorNameChange={this.props.handleChange}
                        errorMessage={this.props.errorMessageSponsor}
                        isUploading={this.props.isUploadingSponsor}
                      />
                    ) : (
                      <div
                        style={{
                          background: "rgb(236, 239, 241)",
                          padding: 10,
                          borderRadius: 5,
                        }}
                      >
                        <InfoIcon
                          style={{
                            height: 15,
                            width: 15,
                            top: 2,
                            position: "relative",
                          }}
                        />
                        {" " + languages.upgrade.upgradeTextExtraSponsor}
                        <br />
                        <Button
                          style={{ marginTop: 5 }}
                          variant="contained"
                          onClick={this.props.toggleUpgradeDialog}
                          color="primary"
                          size="small"
                        >
                          {languages.upgrade.seePackages}
                        </Button>
                      </div>
                    )}
                  </div>
                )}
              </FormGroup>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
              disabled={this.props.name === "" || this.props.startTime === ""}
            >
              {this.props.field
                ? languages.general.save
                : languages.general.add}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
